import { MenuItem, Theme } from "@mui/material";
import { IFormSelect } from "../../../services/custom-forms-data-service/TemplateModels";

import FormProperty from "../../forms/form-property/FormProperty";
import FormSelect from "../../forms/form-select/FormSelect";
import { SxProps } from "@mui/system";

export type CustomFormSelectProps = {
    select: IFormSelect;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};

export default function CustomFormSelect({
    select,
    key,
    sx
}: CustomFormSelectProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormSelect
                    id={select.id}
                    name={select.name}
                    ariaLabel={select.ariaLabel}
                    label={select.label}
                    helperText={select.helperText ?? ' '}
                    readOnly={select.readOnly}
                    sx={{width: '100%'}}>

                        {select.options.map((o, index) => 
                            <MenuItem key={index} value={o.value.toString()}>
                                {o.name}
                            </MenuItem>
                    )}

            </FormSelect>
        </FormProperty>
    );
}
